<template>
	<div class="content">

		<div class="md-layout">
			<div class="md-layout-item md-medium-size-100 md-size-100">

				<md-card>
					<md-card-header data-background-color="purple">
						<h4 class="title">{{$route.name}}</h4>
						<!-- <p class="category">{{$route.name}}</p> -->
					</md-card-header>
					<md-card-content>
						<qrcode-stream @decode="onDecode" @detect="onDetect" style="width:100%;height: 100%;">
						</qrcode-stream>
					</md-card-content>
				</md-card>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		components: {
		},
		data() {
			return {
				show: true,
				loading: "",
				interval: null
			}
		},
		created() {

		},
		methods: {
			onDetect(promise) {
				var self = this;
				promise.then(data => {
					// console.log(data);
				})
				// console.log("hi");
			},
			onDecode(qr) {
				console.log(qr);
				if (String(qr).length == 12) {
					this.$http.post(this.config.api + "/admin/ticket/check_out", {
						checkin_id: qr
					}).then(data => {
						if (data.body.status == 'success') {
							this.$notification.notify({
								message: qr,
								icon: 'done',
								type: 'success'
							})
						}
					})
				}
			},
		}
	}
</script>
<style>
	body {
		background-color: #FFF !important;
	}
</style>



// WEBPACK FOOTER //
// src/pages/CheckOut.vue